import api from "./axios";
import { API_URL } from "../config/env";

const withInstanceParams = (instanceId, params = {}) =>
  instanceId ? { ...params, instanceId } : params;

export const browseMintSpaceCloud = async (mintSpaceId, folderId = null, instanceId = null) => {
  const params = withInstanceParams(instanceId, folderId ? { folderId } : {});
  const response = await api.get(`/mint-space/${mintSpaceId}/cloud/browse`, { params });
  return response.data;
};

export const createCloudFolder = async (mintSpaceId, { name, parentFolder = null, instanceId = null }) => {
  const response = await api.post(`/mint-space/${mintSpaceId}/cloud/folders`, {
    name,
    parentFolder,
    instanceId,
  });
  return response.data;
};

export const updateCloudFolder = async (mintSpaceId, folderId, payload) => {
  const response = await api.patch(`/mint-space/${mintSpaceId}/cloud/folders/${folderId}`, payload);
  return response.data;
};

export const deleteCloudFolder = async (mintSpaceId, folderId, instanceId = null) => {
  const response = await api.delete(`/mint-space/${mintSpaceId}/cloud/folders/${folderId}`, {
    params: withInstanceParams(instanceId),
  });
  return response.data;
};

export const uploadCloudFile = async (mintSpaceId, file, folderId = null, instanceId = null) => {
  const formData = new FormData();
  formData.append("file", file);
  if (file?.name) formData.append("fileName", file.name);
  if (folderId) formData.append("folderId", folderId);
  if (instanceId) formData.append("instanceId", instanceId);
  const response = await api.post(`/mint-space/${mintSpaceId}/cloud/files`, formData);
  return response.data;
};

export const updateCloudFile = async (mintSpaceId, fileId, payload) => {
  const response = await api.patch(`/mint-space/${mintSpaceId}/cloud/files/${fileId}`, payload);
  return response.data;
};

export const getCloudFileContent = async (mintSpaceId, fileId, instanceId = null) => {
  const response = await api.get(`/mint-space/${mintSpaceId}/cloud/files/${fileId}/content`, {
    params: withInstanceParams(instanceId),
  });
  return response.data;
};

export const saveCloudFileContent = async (mintSpaceId, fileId, content, instanceId = null) => {
  const response = await api.put(
    `/mint-space/${mintSpaceId}/cloud/files/${fileId}/content`,
    { content, instanceId }
  );
  return response.data;
};

/** Authenticated blob fetch for image/audio/video preview (private B2 bucket). */
export const fetchCloudFileBlob = async (mintSpaceId, fileId, instanceId = null) => {
  const response = await api.get(`/mint-space/${mintSpaceId}/cloud/files/${fileId}/stream`, {
    params: withInstanceParams(instanceId),
    responseType: "blob",
  });
  return response.data;
};

/** JPEG preview extracted from RAW/DNG (embedded thumbnail). */
export const fetchCloudFilePreviewBlob = async (mintSpaceId, fileId, instanceId = null) => {
  const response = await api.get(`/mint-space/${mintSpaceId}/cloud/files/${fileId}/preview`, {
    params: withInstanceParams(instanceId),
    responseType: "blob",
  });
  return response.data;
};

const instanceQuery = (instanceId, token) => {
  const parts = [];
  if (instanceId) parts.push(`instanceId=${encodeURIComponent(instanceId)}`);
  if (token) parts.push(`access_token=${encodeURIComponent(token)}`);
  return parts.length ? `?${parts.join("&")}` : "";
};

/** Direct stream URL for <img> thumbnails (includes access token query param). */
export const getCloudFileStreamUrl = (mintSpaceId, fileId, instanceId = null) => {
  const base = API_URL.replace(/\/$/, "");
  const token = localStorage.getItem("token");
  return `${base}/mint-space/${mintSpaceId}/cloud/files/${fileId}/stream${instanceQuery(instanceId, token)}`;
};

/** Direct preview URL for RAW/DNG thumbnails in <img> tags. */
export const getCloudFilePreviewUrl = (mintSpaceId, fileId, instanceId = null) => {
  const base = API_URL.replace(/\/$/, "");
  const token = localStorage.getItem("token");
  return `${base}/mint-space/${mintSpaceId}/cloud/files/${fileId}/preview${instanceQuery(instanceId, token)}`;
};

export const deleteCloudFile = async (mintSpaceId, fileId, instanceId = null) => {
  const response = await api.delete(`/mint-space/${mintSpaceId}/cloud/files/${fileId}`, {
    params: withInstanceParams(instanceId),
  });
  return response.data;
};

export const fetchCloudWallpaper = async (mintSpaceId, instanceId = null) => {
  const response = await api.get(`/mint-space/${mintSpaceId}/cloud/wallpaper`, {
    params: withInstanceParams(instanceId),
  });
  return response.data;
};

export const saveCloudWallpaper = async (mintSpaceId, wallpaper, instanceId = null) => {
  const response = await api.put(`/mint-space/${mintSpaceId}/cloud/wallpaper`, {
    ...wallpaper,
    instanceId,
  });
  return response.data;
};
